import { APIS, APP, LANG } from "../constants";
import { authHeader } from "../helpers/authHeader";
import { authHeader2 } from "../helpers/authHeader2";
// import Auth from "../helpers/auth";

export const FormService = {
  get,
  find,
  findWoToken,
  add,
  update,
  remove,
  submitForm,
  uploadForm
};

function uploadForm(file, formId) {
  const formData = new FormData();
  formData.append('version', 1);
  formData.append('file', file);
  formData.append('id', formId);
  const requestOptions = {
    method: APP.REQUEST.POST,
    body: formData,
    headers: {
      // "Authorization": "Bearer " + Auth.get('authToken'),
      // "Content-Type": "multipart/form-data", // content-type header should not be specified!
      "Accept": "application/json"
    }
  };
  return fetch(
    process.env.REACT_APP_API_URL + APIS.FORM.UPLOAD_FILE,
    requestOptions
  ).then(handleResponse);
}

function get() {
  const requestOptions = {
    method: APP.REQUEST.GET,
    headers: authHeader()
  };
  return fetch(
    process.env.REACT_APP_API_URL + APIS.FORM.GET,
    requestOptions
  ).then(handleResponse);
}

function find(formId) {
  const requestOptions = {
    method: APP.REQUEST.GET,
    headers: authHeader()
  };
  return fetch(
    process.env.REACT_APP_API_URL + APIS.FORM.FIND + formId,
    requestOptions
  ).then(handleResponse);
}

function findWoToken(formId) {
  const requestOptions = {
    method: APP.REQUEST.GET,
    headers: authHeader2()
  };
  return fetch(
    process.env.REACT_APP_API_URL + APIS.FORM.FIND + formId,
    requestOptions
  ).then(handleResponse);
}

function add(form) {
  const requestOptions = {
    method: APP.REQUEST.POST,
    body: JSON.stringify(form),
    headers: authHeader()
  };
  return fetch(
    process.env.REACT_APP_API_URL + APIS.FORM.ADD,
    requestOptions
  ).then(handleResponse);
}

function update(form) {
  const requestOptions = {
    method: APP.REQUEST.POST,
    body: JSON.stringify(form),
    headers: authHeader()
  };
  return fetch(
    process.env.REACT_APP_API_URL + APIS.FORM.UPDATE,
    requestOptions
  ).then(handleResponse);
}

function remove(form) {
  const requestOptions = {
    method: APP.REQUEST.POST,
    body: JSON.stringify(form),
    headers: authHeader()
  };
  return fetch(
    process.env.REACT_APP_API_URL + APIS.FORM.DELETE,
    requestOptions
  ).then(handleResponse);
}

function submitForm(form) {
  const requestOptions = {
    method: APP.REQUEST.POST,
    body: JSON.stringify(form),
    headers: authHeader2()
  };
  return fetch(
    process.env.REACT_APP_API_URL + APIS.FORM.SUBMIT,
    requestOptions
  ).then(handleResponse);
}

function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      const error = LANG.APIERROR || (data && data.message) || response.statusText;
      return Promise.reject(new Error(error));
    }
    return data;
  });
}
